<template>
  <q-menu
    v-bind="$attrs"
    v-on="$listeners"
  >
    <q-list
      padding
      :dense="dense"
    >
      <slot name="top" />
      <q-item v-if="vOptions.length === 0">
        <q-item-section>Aucune option</q-item-section>
      </q-item>
      <template
        v-for="option in vOptions"
        v-else
      >
        <q-separator
          v-if="option.separator"
          :key="option.value + '-separator'"
        />
        <q-item
          :key="option.value"
          v-close-popup
          :disable="option.disabled"
          :to="option.to"
          clickable
          @click="onClick(option)"
        >
          <q-item-section
            v-if="option.leftIcon"
            avatar
          >
            <q-icon :name="option.leftIcon" />
          </q-item-section>
          <q-item-section>
            <q-item-label>
              {{
                typeof option[optionLabel] === 'function'
                  ? option[optionLabel](context)
                  : option[optionLabel]
              }}
            </q-item-label>
            <q-item-label
              v-if="option.caption"
              caption
            >
              {{ option.caption }}
            </q-item-label>
          </q-item-section>
          <q-item-section
            v-if="option.icon"
            side
          >
            <q-icon :name="option.icon" />
          </q-item-section>
        </q-item>
      </template>
    </q-list>
  </q-menu>
</template>

<script>/**
 * Composant générique de création de menu
 */

export default {
  name: 'LwfMenu',
  props: {
    /**
     * Défini les options du menu
     * @type {[{ event: String, label: String, icon?: String}]}
     */
    options: {
      type: Array,
      default: _.stubArray
    },
    optionLabel: {
      type: String,
      default: 'label'
    },
    optionValue: {
      type: String,
      default: 'value'
    },
    dense: Boolean,
    context: {
      type: [Object, String],
      default: undefined
    }
  },
  computed: {
    vOptions () {
      const { options, context } = this
      return options.filter(
        (o) => typeof o.if === 'function'
          ? o.if(context)
          : true
      )
    }
  },
  methods: {
    onClick (option) {
      this.$emit('select', option)
      option.cb
        ? option.cb(this.context)
        : this.$emit(option[this.optionValue])
    }
  }
}
</script>

<style scoped>

</style>
